import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceItemForm from './ServiceItemForm'

import { storeServiceItem } from '../services'
import { handleError } from '../../../helpers'

export default function NewServiceItemModal({ visible, onClose, reload, service, scope }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors }, setValue, reset } = useForm({
		defaultValues: { service_id: service.id }
	})

	const onSubmit = values => {
		setLoading(true)
		storeServiceItem(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				reset()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Asociar {scope === 'product' ? 'producto' : 'servicio'} al servicio</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ServiceItemForm 
							register={register}
							errors={errors}
							service={service}
							scope={scope}
							setValue={setValue}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Asociar {scope === 'product' ? 'Producto' : 'Servicio'}
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}